import { useEffect } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

// VIVA-1214 / VIVA-1499 — la pantalla mientras el servidor termina de resolver
// un pago que YA se hizo.
//
// Tapa todo a proposito. Aqui el dinero ya salio y lo unico que falta es que el
// servidor lo confirme: dejar el catalogo usable invita a volver a pulsar
// "Comprar guia" sobre la misma guia, que es justo lo que no debe pasar. Y
// cuando la espera termina en recarga, la pagina va a saltar sola; con la
// pantalla bloqueada eso se lee como el final de algo que estaba en curso y no
// como un salto salido de la nada.
//
// Lleva texto, no solo el giro: bloquear sin decir por que es peor que no
// bloquear.
//
// Existe un overlay equivalente en `components/BussinesPartner/utils/Loading`,
// pero vive dentro de otra feature y pinta sus estilos en linea; este usa la
// hoja de guias, como el resto del modulo.
const GuideActivationOverlay = ({ message }) => {
  // Mientras bloquea, el fondo no se desplaza: si no, la rueda del raton sigue
  // moviendo el catalogo por debajo y el bloqueo se siente a medias.
  useEffect(() => {
    const previo = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previo;
    };
  }, []);

  return (
    <div className="g2-activation-overlay" role="status" aria-live="polite" aria-busy="true">
      <Spin
        size="large"
        indicator={<LoadingOutlined className="g2-activation-overlay-icon" spin />}
      />
      <p className="g2-activation-overlay-text">{message}</p>
    </div>
  );
};

export default GuideActivationOverlay;
